
window.showHideVariantBlock = function($element) {
    $('[data-mapping-variant]').hide();
    $('[data-mapping-variant="' + $element.val() + '"]').show();
};

window.showHideLevel = function($select, change) {
    var $selectLevelContent = $('[data-mapping-element-select-level="level[' + $select.prop('name') + ']"]');
    var elementName = $select.find('option:selected').text().trim();
    var $input = $selectLevelContent.find('input');
    var wireId = $("div.Polaris-Page[wire\\:id]").attr("wire:id");

    if ($select.prop('name') !== 'product_id' && $select.prop('name') !== 'product_variant_2_id') {
        return false;
    }

    if (elementName.indexOf('@') === -1) {
        $selectLevelContent.hide();

        if ($input.val() !== '') {
            $input.val('');
            if (wireId && $input.attr("wire:model")) {
                Livewire.find(wireId).set($input.attr("wire:model"), '');
            }
        }
    }
    else {
        $selectLevelContent.show();

        if ((change || !$input.val()) && $select.is('select[name="product_id"]')) {
            var value = elementName.substr(0, elementName.indexOf('@'));
            if (value.indexOf('ITEMS/ITEM/') !== -1) {
                value = 'ITEMS/ITEM';
            } else if (value.indexOf('SHOP/ITEM/') !== -1) {
                value = 'SHOP/ITEM';
            } else if (value.indexOf('SHOP/SHOPITEM/') !== -1) {
                value = 'SHOP/SHOPITEM';
            }
            $input.val(value);

            if (wireId) {
                Livewire.find(wireId).set($input.attr("wire:model"), value);
            }
        }
        if ((change || !$input.val()) && $select.is('select[name="product_variant_2_id"]')) {
            var value = elementName.substr(0, elementName.indexOf('@'));
            if (value.indexOf('/VARIANT/') !== -1) {
                value = value.substr(0, value.indexOf('/VARIANT/') + 8);
            } else if (value.indexOf('/variant/') !== -1) {
                value = value.substr(0, value.indexOf('/variant/') + 8);
            }
            $input.val(value);

            if (wireId) {
                Livewire.find(wireId).set($input.attr("wire:model"), value);
            }
        }
    }
};

window.refreshVisibilityRowParameter = function($content) {
    $content.find('select').each(function(i, el) {
        var $select = $(el);
        var $row = $select.closest('[data-feedmapping-parameter-row]');
        var attribute = $row.find('input').eq(0).val();

        if (((!$select.val()) || ($select.val() === 0) || ($select.val() === "0")) && !attribute) {
            $row.hide();
        }
    });
};

$(document).ready(() => {
    if (typeof Livewire !== 'undefined') {
        Livewire.hook('element.updated', (el, component) => {
            handleFeedMappingStepChoices();
        });
    }
});

window.feedMappingChoicesBound = false;
window.feedMappingButtonsBound = [false, false];
window.handleFeedMappingStepChoices = function() {

    //console.log('handleFeedMappingStepChoices');

    window.bindFeedMappingChoices();

    showHideVariantBlock($('[name="variant_type"]:checked'));
    showHideLevel($('select[name="product_id"]'), false);
    showHideLevel($('select[name="product_variant_2_id"]'), false);


    $('[data-feedmapping-parameter-content]').each(function(i, el) {

        var $content = $(el);
        refreshVisibilityRowParameter($content);

        if (window.feedMappingButtonsBound[i]) {
            return;
        }
        window.feedMappingButtonsBound[i] = true;
        $content.find('[data-feedmapping-btn-add-parameter]').not('.eventIsBound').addClass("eventIsBound").on('click', function(ev) {
            ev.preventDefault();
            var $hiddenRow = $content.find('[data-feedmapping-parameter-row]:hidden').eq(0);
            $hiddenRow.show();

            // pokud už žádné nejsou tak schováme tlačítko
            if ($content.find('[data-feedmapping-parameter-row]:hidden').length === 0) {
                $content.find('[data-feedmapping-btn-add-parameter-content]').hide();
            }
        });


    });
};

window.bindFeedMappingChoices = function() {
    $('[name="variant_type"]').on('change', function() {
        showHideVariantBlock($(this));
        $('[data-feedmapping-parameter-content]').each(function(i, el) {
            refreshVisibilityRowParameter($(el));
        });
    });
    $('select[name="product_id"], select[name="product_variant_2_id"]').on('change', function(ev) {
        showHideLevel($(this), true);
    });

    window.feedMappingChoicesBound = true;
};

$(document).ready(function(){

    //console.log('document is ready');
    handleFeedMappingStepChoices();
    if ($('body').data('router-name') !== 'connection-feed-mapping-edit' && $('body').data('router-name') !== 'connection-export-connection-feed-mapping-edit') {
        return;
    }


});

$(document).ready(function(){
    if (typeof Livewire == 'undefined') {
        return;
    }
    if ($('body').data('router-name') !== 'connection-import-connection-wizard' && $('body').data('router-name') !== 'connection-export-connection-wizard') {
        return;
    }
    Livewire.hook('element.initialized', (el, component) => {
        //console.log('INITIALIZED', el, component);
        window.feedMappingChoicesBound = false;
        window.feedMappingButtonsBound = [false, false];
    });
    Livewire.hook('element.updated', (el, component) => {
        if ($(el).is("[data-mapping-variant]")) {
            handleFeedMappingStepChoices();
        }
        if ($(el).is("[data-feedmapping-parameter-content]")) {
            handleFeedMappingStepChoices();
            refreshVisibilityRowParameter($(el));
        }
    });

});
